
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-stencil-demo-plugin-stencil"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.zh.md?type=demo')
};